import { expressionDefinitionApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const LOAN_ROLE_ASSIGNMENT_CRITERIA_ACTION_TYPE = createNamedActions(
  'loanRoleAssignmentCriteria',
  {
    GET_LOAN_ROLE_ASSIGNMENT_CRITERIA_SCHEMA: 'GET_LOAN_ROLE_ASSIGNMENT_CRITERIA_SCHEMA',
  },
);

export const getLoanRoleAssignmentCriteriaSchemaAction = catchAsyncActionError(
  () => async dispatch => {
    const { data } = await expressionDefinitionApi.getLoanRoleAssignmentExpressionDefinition();

    return dispatch({
      type: LOAN_ROLE_ASSIGNMENT_CRITERIA_ACTION_TYPE.GET_LOAN_ROLE_ASSIGNMENT_CRITERIA_SCHEMA,
      payload: data,
    });
  },
);
